import { IInitialState } from 'store/models';
import { stateSelector } from '../stateSelector';

export function templatesStateSelector(state: IInitialState) {
	return stateSelector(state).templates;
}
